import {
  ButtonPrimaryTextOnly,
  ButtonSecondary,
  Flex,
  ModalBody,
  ModalHeader,
  ModalRoot,
  styled,
} from '@creditas-ui/react';
import type React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useEjnSelected } from '../../../contexts/ejn';
import { useEjnActions } from '../../../hook/useEjnActions';
import { addFeedback } from '../../../store/reducers/feedback';
import { invalidAddress } from '../../../utils/helpers';
import { EnjAddress } from './EnjAddress';

const ModalBodyStyled = styled(ModalBody)`
  margin-bottom 25px;
`;

const ModalHeaderStyled = styled(ModalHeader)`
  > div {
    > h3 {
      font-size: 18px;
      font-weight: 500;
      letter: 0.3px
    }
  }
`;

const CancelButton = styled(ButtonSecondary)`
  width: 20%;
`;

const ConfirmButton = styled(ButtonPrimaryTextOnly)`
  width: 30%;
`;

export const EjnSendNotification: React.FC = () => {
  const dispatch = useDispatch();

  const { onClose, sendNotificationVisible } = useEjnActions();
  const [showEditAddress, setShowEditAddress] = useState(false);
  const { ejn, decide, decision } = useEjnSelected();

  const closeModal = useCallback(() => {
    setShowEditAddress(false);
    onClose();
  }, [onClose]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (decision.success) {
      closeModal();
      dispatch(
        addFeedback({
          text: 'Nova notificação enviada com sucesso',
          type: 'success',
        }),
      );
    }

    if (decision.error) {
      dispatch(
        addFeedback({
          text: 'Erro ao enviar nova notificação',
          type: 'error',
        }),
      );
    }
  }, [decision, dispatch]);

  return (
    <ModalRoot
      closeModal={closeModal}
      size="medium"
      isOpen={sendNotificationVisible}
    >
      <ModalHeaderStyled title="Renotificar contrato" />
      <ModalBodyStyled resetStyle={true}>
        <EnjAddress
          showEditAddress={showEditAddress}
          setShowEditAddress={setShowEditAddress}
        />
      </ModalBodyStyled>
      {!showEditAddress && (
        <Flex justifyContent="right" margin="25px">
          <CancelButton
            data-testid="cancelButton"
            onClick={closeModal}
            size="medium"
            disabled={decision.loading}
          >
            Cancel
          </CancelButton>

          <ConfirmButton
            data-testid="confirmButton"
            size="medium"
            onClick={() => decide('NOTIFY')}
            style={{ maxHeight: '66px' }}
            type="button"
            disabled={
              decision.loading ||
              ejn?.notification.status !== 'PENDING_DECISION' ||
              invalidAddress(ejn?.notification.address)
            }
            loading={decision.loading}
          >
            Renotificar
          </ConfirmButton>
        </Flex>
      )}
    </ModalRoot>
  );
};
